<template>
  <div class="otto-settings">
    <div class="arrow-up"></div>
    <div class="otto-settings__content">
      <div class="otto-info">
        <div class="otto-info__title">
          {{info.name}}
        </div>
        <div class="otto-info__location">
          {{info.mailing_address_line_1}}<br />
          {{info.mailing_address_city}}, {{info.mailing_address_state}}
        </div>
      </div>
       <div class="otto-btn otto-btn__logout" @click="onLogout"><span class="otto-btn-text">LOG OUT</span></div>
    </div>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { ADD_TOAST_MESSAGE } from 'vuex-toast';
import PopupMixin from '@/mixins/popup';

export default {
  name: 'settings',
  mixins: [PopupMixin],
  data() {
    return {};
  },
  computed: {
    ...mapState({
      info: state => state.business.info,
      showSettings: state => state.ui.showSettings,
    }),
  },
  watch: {
    showSettings(newValue) {
      if (newValue === true) {
        this.setupListener(this.closeSettings);
      } else {
        this.removeListener();
      }
    },
  },
  methods: {
    ...mapActions([
      'logout',
      'closeSettings',
    ]),
    ...mapActions({
      addToast: ADD_TOAST_MESSAGE,
    }),
    onLogout() {
      this.logout()
        .then(() => {
          this.removeListener();
          this.closeSettings();
          this.$router.replace('login');
          this.addToast({
            text: 'You have logged out successfully.',
            type: 'success',
          });
        });
    },
  },
};
</script>

<style lang="sass">
  .otto-settings
    position: absolute
    top: 55px
    right: 12px
    z-index: 2
    width: 280px
    height: 180px
    box-shadow: 0 4px 16px 0 rgba(9,28,46,0.30)
    border-radius: 4px
    text-align: center

    &__content
      width: 100%
      height: 100%
      background: #fff
      display: flex
      justify-content: center
      align-items: center
      flex-direction: column

  .otto-info
    line-height: 24px
    margin-bottom: 25px
    &__location
      font-size: 18px
      color: #9B9B9B
    &__title
      font-size: 20px
      color: #000000
</style>




// WEBPACK FOOTER //
// src/components/Settings.vue